import React from 'react';
import { connect } from 'react-redux';
import queryString from 'query-string';
import LoginPage from '../LoginPage';

const getFeedUrlFromLocation = location => {
  const { feedUrl } = queryString.parse(location.search);

  return feedUrl ? decodeURIComponent(feedUrl) : null;
};

const mapStateToProps = ({ user: { menuMode } }, { location }) => ({
  feedUrl: getFeedUrlFromLocation(location),
  menuMode,
});

export default connect(mapStateToProps)(LoginPage);
